import { getDateAndTimeFormat } from '@/utils/utils';

export const spaceName = 'odMenus';
export interface MenusSettings {
  viewMode: 'gridView' | 'listView';
  selectedIds: Number[];
  currentPageInfo: {
    data: any;
    params: {
      currentPage: Number;
      pageSize: Number;
      total: Number;
    };
  };
  searchItem: string | false;
}

export default {
  viewMode: 'gridView',
  selectedIds: [],
  currentPageInfo: {
    data: [],
    params: {
      currentPage: 1,
      pageSize: 12,
      total: 0,
    },
  },
  searchItem: false,
} as MenusSettings;

export const getListViewColumns = (props: any) => {
  const {
    helper: { tx },
    actionButton,
    validPeriod,
    od: { editingBusiness },
  } = props;

  return [
    {
      title: tx('Management_Menu_Detail.menu_name'),
      width: 200,
      dataIndex: 'name',
      key: 'name',
      // sorter: (a: any, b: any) => a.name.localeCompare(b.name),
      ellipsis: true,
      fixed: 'left',
    },
    {
      title: tx('Management_Menu_List_View.status'),
      dataIndex: 'isPublished',
      key: 'isPublished',
      width: 150,
      // filters: [
      //   {
      //     text: tx('t_Published'),
      //     value: 'true',
      //   },
      //   {
      //     text: tx('t_Unpublished'),
      //     value: 'false',
      //   },
      // ],
      render: (item: any) => (item === 'true' ? 'Published' : 'Unpublished'),
      // onFilter: (value: any, record: any) => [record.isPublished].indexOf(value) >= 0,
    },
    validPeriod,
    {
      title: tx('Global.recommend'),
      dataIndex: 'isRecommended',
      key: 'isRecommended',
      width: 150,
      // filters: [
      //   {
      //     text: tx('t_true'),
      //     value: 'true',
      //   },
      //   {
      //     text: tx('t_false'),
      //     value: 'false',
      //   },
      // ],
      // onFilter: (value: any, record: any) => [record.isRecommended].indexOf(value) >= 0,
      // sorter: (a: any, b: any) => a.isRecommended.localeCompare(b.isRecommended),
    },
    {
      title: tx('Global.created_at'),
      dataIndex: 'createdAt',
      key: 'createdAt',
      // sorter: (a: any, b: any) => a.createdAt.localeCompare(b.createdAt),
      ellipsis: true,
      width: 150,
      render: (time: string) => getDateAndTimeFormat(time),
    },
    {
      title: tx('Global.updated_at'),
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      // sorter: (a: any, b: any) => a.updatedAt.localeCompare(b.updatedAt),
      ellipsis: true,
      width: 150,
      render: (time: string) => getDateAndTimeFormat(time),
    },
    actionButton,
  ];
};
